// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"b5eb8f6f","91":"4afdf480","367":"3e6c39a9","503":"cdcb3fa7","561":"511e725f","765":"ef728769","777":"63de907d","867":"0c1849dc","884":"b84d029b"}[chunkId] + ".js";
};